import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-100 col-md-50" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/public/skechfab/loginPage.png",
      class: "w-100"
    })
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-100 col-md-50" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/public/skechfab/createAccount.png",
      class: "w-100"
    })
  ])
], -1)
const _hoisted_3 = { class: "my-5" }

import { DialogHandler } from "../DialogHandler";
import CoreDialog from "../../../../framework/components/dialog/CoreDialog.vue";
import { useRoute } from "vue-router";
import { translation } from "../../../lang/Translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'SketchFabAuthDialog',
  setup(__props) {

const t = translation;

/* プロパティ */
const route = useRoute();
const project_id = route.params.project_id as string;
const title = "Sketch Fab";
const dialogId = DialogHandler.sketchFabAuthDialogId;

const sckechFabConnection = () => {
  const returnUrl = `${location.protocol}//${location.host}/`;
  let url = `https://sketchfab.com/oauth2/authorize/`;
  url += `?state=${project_id}&response_type=code`
  url += `&client_id=AmxzBpjVoA8x04CfFrpugw81WT58rGhJjdpypTPm`
  url += `&redirect_uri=${returnUrl}v1/sketchfab/receive`;
  location.href = url;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CoreDialog, {
      id: _unref(dialogId),
      title: title
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("h5", null, _toDisplayString(_unref(t).to("3Dモデルサイト Skechfab","skechfab_title")), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t).to("SkechFabにアップロードされた沢山の高品質な３DモデルをBLOCKVROCKに追加することができます。","sf_contents1")), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t).to("Skechfabと連携するためには、Skechfabのアカウントを作成してログインする必要があります。","sf_contents2")), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref(t).to("この画面の一番下の","sf_contents3")) + " ", 1),
            _createElementVNode("button", {
              class: "btn btn-primary btn-sm",
              onClick: sckechFabConnection
            }, _toDisplayString(_unref(t).to("Skechfabと連携","sf_connect_btn")), 1),
            _createTextVNode(" " + _toDisplayString(_unref(t).to("ボタンでSkechfabのアカウント作成を実施します。","sf_contents4")), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_unref(t).to("すでにSkechfabアカウントをお持ちの場合は、次の画面でログインしてください","sf_contents5")), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t).to("Skechfabアカウントがない場合は「Create an account」をクリックします。","sf_contents6")), 1),
          _hoisted_1,
          _createElementVNode("p", null, _toDisplayString(_unref(t).to("「Create an account」をクリックした先の「Signup」画面の上部でメールアドレスを入力するか、または画面下部にあるソーシャルアカウント連携ボタンでアカウントを作成します。","sf_contents7")), 1),
          _hoisted_2,
          _createElementVNode("p", null, _toDisplayString(_unref(t).to("ログインができたら「ACCEPT」ボタンで連携を承認します。","sf_contents8")), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "mb-5 btn btn-lg btn-primary w-100",
              onClick: sckechFabConnection
            }, _toDisplayString(_unref(t).to("Skechfabと連携","sf_connect_btn")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["id"])
  ]))
}
}

})